import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  ClaimProductState,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.claim}claims/${COMMON_QUERY_PARAMS.CLAIM_ID}/reason`;

interface SetReasonForClaimArgs {
  claimId: string;
  reasonId: string;
  reasonComment?: string;
}

const setReasonForClaim = async ({
  claimId,
  reasonId,
  reasonComment,
}: SetReasonForClaimArgs): Promise<
  BackResponse<ClaimProductState> | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.CLAIM_ID, claimId);

    const response = await apiCall<BackResponse<ClaimProductState>>(url, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        reasonId,
        reasonComment: reasonComment || '',
        diagnosticComment: '',
      },
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default setReasonForClaim;
